import { useStaticQuery, graphql } from 'gatsby';

import type { StrapiFooterNavItem } from '@customTypes/strapiData';

export const useFooterNav = () => {
  const {
    allStrapiFooterNav: { nodes },
  } = useStaticQuery(graphql`
    {
      allStrapiFooterNav {
        nodes {
          title
          rank
          items {
            title
            subtitle
            url
            externalUrl
            showAsLink
            icon {
              localFile {
                publicURL
              }
            }
          }
        }
      }
    }
  `);

  return nodes.sort((a: StrapiFooterNavItem, b: StrapiFooterNavItem) => a.rank - b.rank);
};
